import axios from "axios";

export const receivedDocApi = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND!}api/stk-received-document`,
  headers: { "Content-Type": "application/json" },
});
